<ub-card [rounded]="true">
  @let options = card().options;
  <h3 title class="t-upper t-weight--normal" *ngIf="options.title">{{ options.title }}</h3>
  <div class="wysiwyg-content" content>
    <quill-view [content]="options.paragraph"></quill-view>
  </div>
</ub-card>
